var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-main"},[_c('header',{staticClass:"page-header"},[_vm._t("header")],2),_vm._v(" "),_c('main',{staticClass:"page-body"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }